module.exports = __webpack_public_path__ + "img/yf1.6f8e3f04.jpg";